import { createFileRoute } from '@tanstack/react-router'
import { requireRoles } from '@/lib/middleware'
import { WorkerReportRoute } from '@/features/worker-incidents/my-report/worker-report-route'

/** `/my-incident-reports/<id>`: a support worker's own report (status, files, tasks, shared summary). */
export const Route = createFileRoute(
  '/_authenticated/_organization/my-incident-reports/$incidentId'
)({
  beforeLoad: async () => requireRoles(['health_carer', 'supported_employee']),
  component: WorkerReportRoute,
})
